import React from 'react';
import styled from 'styled-components';
import { StaticQuery, Link, graphql } from 'gatsby';
import SEO from '../seo';

const BlogContainer = styled.div``;
const Blog = styled.div`
  margin: 2rem auto;
`;
const Header = styled.p``;
const BlogDate = styled.small`
  display: flex;
  justify-content: flex-end;
  color: var(--color-tertiary);
`;

const BlogHeader = styled.h2`
  color: var(--color-primary);
  &:hover {
    background-color: var(--color-primary);
    color: var(--color-background);
  }
`;

const Blogs = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allMarkdownRemark(
            sort: { fields: [frontmatter___date], order: DESC }
          ) {
            nodes {
              excerpt
              fields {
                slug
              }
              frontmatter {
                date(formatString: "MMMM DD, YYYY")
                title
                description
              }
            }
          }
        }
      `}
      render={data => {
        const posts = data.allMarkdownRemark.nodes;

        return (
          <BlogContainer>
            <SEO title="Blogs" />
            <Header>
              I don’t talk a lot but when I do I write a blog about it.
            </Header>

            {posts.map(post => {
              const title = post.frontmatter.title || post.fields.slug;

              return (
                <Blog key={post.fields.slug}>
                  <Link to={post.fields.slug}>
                    <BlogHeader>{title}</BlogHeader>
                  </Link>

                  <BlogDate>{post.frontmatter.date}</BlogDate>

                  <p
                    dangerouslySetInnerHTML={{
                      __html: post.frontmatter.description || post.excerpt,
                    }}
                  />
                </Blog>
              );
            })}
          </BlogContainer>
        );
      }}
    />
  );
};

export default Blogs;
